<!--

  當開啟時才渲染 Dialog，並在關閉後的一定時間後移除，減少大量使用時的資源損耗

  Example:

  <ModalOpener v-model="isOpen">
    <template #activator="{ props }">
      <slot v-bind="{ props }">
        <v-btn v-bind="props" ... >
          Open the dialog
        </v-btn>
      </slot>
    </template>
    <template #dialog="{ props }">
      <v-dialog v-bind="props" ... > ... </v-dialog>
    </template>
  </ModalOpener>

  const isOpen = ref(false)
-->

<template>
  <slot name="activator" v-bind="{ props: activatorProps }">
  </slot>
  <Teleport v-if="isOpened" to="body">
    <slot name="dialog" v-bind="{ props: dialogProps }">
    </slot>
  </Teleport>
</template>

<script setup lang="ts">
const emit = defineEmits(['update:modelValue'])

let gcTimer: ReturnType<typeof setTimeout>

const props = withDefaults(defineProps<{
  closeTimeout?: number,
  modelValue?: boolean,
  activator?: any,
}>(), {
  closeTimeout: 3000,
  modelValue: false,
})

const isOpened = ref(props.modelValue)

function open() {
  clearTimeout(gcTimer)
  isOpened.value = true
  props.modelValue || emit('update:modelValue', true)
}

function close() {
  // 對話關閉後，等待 GC 時間後清除 dialog
  props.modelValue && emit('update:modelValue', false)
  clearTimeout(gcTimer)
  gcTimer = setTimeout(() => {
    isOpened.value = false
  }, props.closeTimeout)
}

const dialogProps = computed(() => ({
  modelValue: props.modelValue,
  // 當 modal 主動關閉時，例如點擊外圍，傳遞狀態
  'onUpdate:modelValue': (val: boolean) => emit('update:modelValue', val) 
}))


const activatorProps = computed(() => ({
  onClick: () => open(),
}))

watch(() => props.modelValue, () => {
  // 對話框開啟
  if (props.modelValue) {
    open()
  } else {
    close()
  }
})

defineExpose({
  open,
  close,
})

</script>
